module.exports = __webpack_public_path__ + "static/campaign-builder-templates-f021d6f1b2ddb6339e2fc619ff3bddd1.svg";